<template>
<div class="settings">
    <div class="columns">
        <div class="column is-one-quarter">
            <div class="columns">
                <div class="column is-11">
                    <settings-menu active-item="details"></settings-menu>
                </div>
            </div>
        </div>
        <div class="column">
            <div class="settings-container">
                <div class="columns">
                    <div v-if="loadingUser" class="column is-full has-text-centered">
                        <img src="/loader-dark.svg">
                    </div>
                    <div v-if="user" class="column is-full">
                        <div class="columns is-multiline">
                            <div class="column is-12">
                                <div v-show="!loadedEmail && !successfulUpdated" class="notification is-danger" style="font-size: 13px;">
                                    Because your account was created using Github, we could not get your email address.
                                    Having an email address associated with your account is important because you will be informed when new
                                    cloudlets are discovered or when something is not ok with your backups.
                                    <b>Please add your email address.</b>
                                </div>
                            </div>
                            <div class="column is-3">
                                <div class="plan-page-label">Details</div>
                                <div class="plan-page-description" style="font-size:13px !important;">
                                    Update the first name, last name and email address of your Weap.io account.
                                </div>
                            </div>
                            <div class="column is-9" style="padding-left: 60px;">
                                <div class="columns is-multiline">
                                    <div class="column is-half">
                                        <input v-model="user.first_name" @keyup.enter="updateUser" type="text" class="input custom-input-size is-medium" :disabled="updatingUser" :class="{ 'is-danger': hasError('first_name') }" placeholder="First Name">
                                        <span v-if="hasError('first_name')" class="help is-danger">{{ getError('first_name') }}</span>
                                    </div>
                                    <div class="column is-half">
                                        <input v-model="user.last_name" @keyup.enter="updateUser" type="text" class="input custom-input-size is-medium" :disabled="updatingUser" :class="{ 'is-danger': hasError('last_name') }" placeholder="Last Name">
                                        <span v-if="hasError('last_name')" class="help is-danger">{{ getError('last_name') }}</span>
                                    </div>
                                    <div class="column is-full">
                                        <input v-model="user.email" @keyup.enter="updateUser" id="email" type="text" class="input custom-input-size is-medium" :disabled="updatingUser" :class="{ 'is-danger': hasError('email') }" placeholder="Email">
                                        <span v-if="hasError('email')" class="help is-danger">{{ getError('email') }}</span>
                                    </div>
                                    <div class="column is-full">
                                        <div @click="updateUser" id="save-details" :disabled="updatingUser" :class="{ 'is-loading': updatingUser }" class="button custom-button-size is-fullwidth is-info">Save changes</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Api from '@/api';
import Swal from 'sweetalert2';
import FormErrorsMixin from '@/mixins/FormErrors';

import SettingsMenu from '@/components/Settings/Menu.vue';

export default {
    components: {
        SettingsMenu,
    },

    mixins: [FormErrorsMixin],

    metaInfo: {
        title: 'Account Details - Weap.io',
    },

    data() {
        return {
            user: null,
            loadedEmail: null,
            successfulUpdated: false,
            loadingUser: false,
            updatingUser: false,
            allowedInputs: ['first_name', 'last_name', 'email'],
        }
    },

    mounted() {
        this.getUser();
    },

    methods: {
        getUser() {
            this.loadingUser = true;
            Api().get('users/current')
                .then((response) => {
                    this.user = response.data.data;
                    this.loadedEmail = this.user.email;
                })
                .catch((error) => {

                })
                .finally(() => {
                    this.loadingUser = false;
                });
        },

        updateUser() {
            if (this.updatingUser) {
                return;
            }

            this.updatingUser = true;
            this.resetErrors();

            let endpoint = 'users/' + this.user.id;

            Api().put(endpoint, this.user)
                .then((response) => {
                    Swal.fire({
                        title: 'Done!',
                        text: 'Your account details are updated.',
                        type: 'success',
                    });
                    Event.$emit('updateEmailInLocalStorage', this.user.email);
                    this.successfulUpdated = true;
                })
                .catch((error) => {
                    if (!this.storeErrors(error.response.data.errors)) {
                        var message = 'Something wrong happened. Refresh the page and try again.';
                        if (typeof error.response.data.message == 'string') {
                            message = error.response.data.message;
                        }

                        Swal.fire({
                            title: 'Oops',
                            text: message,
                            type: 'error',
                        });
                    }
                })
                .finally(() => {
                    this.updatingUser = false;
                });
        },
    },
}
</script>
